var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRate = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 23,
  viewBox: "0 0 24 23",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#595959",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M389.072 218.002c-.702-.033-1.337.403-1.561 1.068l-2.182 6.484h-6.758c-.676 0-1.277.433-1.49 1.076-.214.642.007 1.35.547 1.758l5.432 4.081-1.96 6.502c-.194.642.04 1.335.58 1.73.543.393 1.274.398 1.822.016l5.5-3.85 5.496 3.85c.548.382 1.28.377 1.822-.016.54-.395.774-1.088.58-1.73l-1.96-6.502 5.432-4.081c.54-.408.761-1.116.547-1.758-.213-.643-.814-1.076-1.49-1.076h-6.758l-2.182-6.484c-.208-.615-.771-1.04-1.417-1.068zm-.043.942c.259.012.482.181.565.428l2.398 7.127h7.437c.272 0 .51.174.596.43.085.257-.003.54-.219.703l-5.959 4.48 2.151 7.13c.174.573-.472 1.041-.96.701l-6.037-4.23-6.04 4.23c-.487.34-1.133-.128-.96-.7l2.152-7.132-5.96-4.479c-.482-.362-.225-1.133.378-1.133h7.437l2.398-7.127c.088-.267.344-.44.623-.428z",
  transform: "translate(-377 -218)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRate);
export default ForwardRef;